import {} from '@famly/stat_forms_stat-form';
import {} from './kinder-connect-capture-settings-form-values';
export const defaultConfig = {};
